// extracted by mini-css-extract-plugin
module.exports = {"footer":"_b2520c3","buttons":"_4d31d9e"};